import { render, staticRenderFns } from "./ButtonTemplate.vue?vue&type=template&id=48d4117b&scoped=true&"
import script from "./ButtonTemplate.vue?vue&type=script&lang=js&"
export * from "./ButtonTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTemplate.vue?vue&type=style&index=0&id=48d4117b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4117b",
  null
  
)

export default component.exports